module.exports = __webpack_public_path__ + "static/media/bug-fixes.e092c8e3.svg";